// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseApServiceSettingsAreaRoutes = {
  route: '/ap-service-settings',
}

export const ApServiceSettingsAreaRoutes = transformRoutes(
  BaseApServiceSettingsAreaRoutes,
)
